import React, { useState } from 'react';
import classNames from 'classnames';
import { arrayUtils } from '@indico-data/utils';
import { DragDropVerticalList, Icon } from 'Permafrost/index';
import { DragDropListItem } from './OldDragDropListItem';
import { StyledOldDragDropList, StyledAddItemContainer } from './OldDragDropList.styles';
export const OldDragDropList = (props) => {
    const { id, arrows = true, canDelete, className, header, items, onAdd, onDelete, onEdit, onMovedItem, subHeader, disabledDeleteTargets, } = props;
    const [draggedItem, setDraggedItem] = useState('');
    // adding new items to the list
    const [newItemOpen, setNewItemOpen] = useState(false);
    const [newValue, setNewValue] = useState('');
    // tracks whether a reordering arrow has been pressed, and which items are affected
    const [swapItems, setSwapItems] = useState([
        undefined,
        undefined,
    ]);
    // updateItemOrder is called on arrow button up/down
    const updateItemOrder = ({ destination, source }) => {
        if (destination === undefined || destination === source) {
            return;
        }
        setSwapItems([source, destination]);
        const reorderedItems = arrayUtils.reorderItem(items.map((item) => item.name), source, destination);
        setTimeout(() => {
            onMovedItem(reorderedItems);
            setSwapItems([undefined, undefined]);
        }, 300);
    };
    const addItem = () => {
        if (newValue !== '' && newValue.length >= 2) {
            const current = [...items.map((item) => item.name), newValue];
            onAdd && onAdd(current);
            // clear state and close “add item” input once added
            setNewValue('');
            setNewItemOpen(false);
        }
    };
    const editItem = (itemToEdit, editedItem) => {
        const current = [...items.map((item) => item.name)];
        const itemIndex = current.indexOf(itemToEdit);
        current[itemIndex] = editedItem;
        onEdit && onEdit(current);
    };
    // determines reordering direction, and applies appropriate css class
    const animateDirection = (itemIndex) => {
        const sourceIndex = swapItems[0];
        const destIndex = swapItems[1];
        if (Number.isInteger(sourceIndex) && Number.isInteger(destIndex) && sourceIndex !== destIndex) {
            // @ts-ignore
            const direction = sourceIndex > destIndex ? 'up' : 'down';
            const itemIsSource = itemIndex === sourceIndex;
            const itemIsDest = itemIndex === destIndex;
            if (itemIsSource) {
                return direction === 'up' ? 'animate-up' : 'animate-down';
            }
            if (itemIsDest) {
                return direction === 'up' ? 'animate-down' : 'animate-up';
            }
        }
        return '';
    };
    return (React.createElement(StyledOldDragDropList, { id: id, className: className, "data-cy": props['data-cy'], style: !header && !subHeader ? { borderLeft: 'none' } : {} },
        header && (React.createElement("h4", { className: "list-header t-bold", "data-testid": "main-header" }, header)),
        subHeader && (React.createElement("h5", { className: "sub-header", "data-testid": "sub-header" }, subHeader)),
        React.createElement(DragDropVerticalList, { itemIdList: items.map((item) => item.name), items: items.map((item, i) => {
                var _a;
                return (React.createElement(DragDropListItem, { key: item.id, arrows: arrows, canDelete: canDelete, className: classNames(animateDirection(i)), disableDeleteTooltipText: (_a = disabledDeleteTargets === null || disabledDeleteTargets === void 0 ? void 0 : disabledDeleteTargets.find((disabledDeleteField) => disabledDeleteField.targetId === item.id)) === null || _a === void 0 ? void 0 : _a.disableDeleteTooltipText, index: i, isDragging: item.name === draggedItem, item: item, listLength: items.length, onDelete: onDelete, onEdit: editItem, updateItemOrder: updateItemOrder }));
            }), itemsVerticalGap: "3px", onDrop: onMovedItem, updateDraggedItem: setDraggedItem }),
        onAdd && (React.createElement(StyledAddItemContainer, { className: !newItemOpen ? 'dash-border' : 'solid-back' },
            !newItemOpen && (React.createElement("button", Object.assign({ className: "add-btn", onClick: () => setNewItemOpen(true), "aria-label": "add list item" }, props === null || props === void 0 ? void 0 : props.addButtonProps),
                React.createElement(Icon, { name: "plus", size: [20] }))),
            newItemOpen && (React.createElement(React.Fragment, null,
                React.createElement("input", Object.assign({ type: "text", autoFocus: true, className: "add-item-input", value: newValue, onChange: (e) => setNewValue(e.target.value), onKeyDown: (e) => {
                        if (e.key === 'Enter' && !items.some((item) => item.name === newValue)) {
                            e.preventDefault();
                            addItem();
                        }
                    } }, props === null || props === void 0 ? void 0 : props.inputProps)),
                React.createElement("button", Object.assign({ "aria-label": "add new item", className: "confirm", onClick: () => addItem(), disabled: newValue === '' ||
                        newValue.length < 2 ||
                        items.some((item) => item.name === newValue) }, props === null || props === void 0 ? void 0 : props.confirmButtonProps),
                    React.createElement(Icon, { name: "check", size: [18] })),
                React.createElement("button", { "aria-label": "cancel new item", className: "cancel", onClick: () => {
                        setNewItemOpen(false);
                        setNewValue('');
                    } },
                    React.createElement(Icon, { name: "x-close", size: [16] }))))))));
};
//# sourceMappingURL=OldDragDropList.js.map